/* @flow */
import * as React from 'react';
import { connect } from 'react-redux';

import Button from 'components/Button';
import Buttons from 'components/Buttons';
import Text from 'components/Text';
import Glyph from 'components/Glyph';
import userAgent from 'lib/currentUserAgent';
import LinkConstants from 'constants/LinkConstants';
import AdminUpgradeHelp from 'admin/components/AdminUpgradeHelp';
import EventTracking from 'lib/EventTracking';
import ZopimButton from 'support/components/ZopimButton';

import './styles/AdminUpgradePageHeader.scss';

type Props = {
  title: string,
  startUrl?: string,
  quoteUuid?: string,
  hideHelp?: boolean,
  hideClose?: boolean,
  screen?: string,
  useHref?: boolean,
  remindIconOnClickEventKey?: string,
};

class AdminUpgradePageHeader extends React.Component<Props> {
  getEventTrackingKey = (postfix: string) => {
    const { screen } = this.props;
    if (screen) {
      return `${screen}.${postfix}`;
    }
    return undefined;
  };

  track = (key: ?string) => {
    if (key) {
      EventTracking.trackKey(key);
    }
  };

  renderRemindIcon = () => {
    const { startUrl, useHref, remindIconOnClickEventKey } = this.props;
    const remindIcon = <Glyph name="remind-icon" color="brand" size="xxlarge" solo />;
    if (startUrl && useHref) {
      return (
        <Button level="icon" href={startUrl} aria-label="Back" eventKey={remindIconOnClickEventKey}>
          {remindIcon}
        </Button>
      );
    } else if (startUrl) {
      return (
        <Button level="icon" to={startUrl} aria-label="Back" eventKey={remindIconOnClickEventKey}>
          {remindIcon}
        </Button>
      );
    } else {
      return (
        <Button
          level="icon"
          href={LinkConstants.PLANS}
          target="_blank"
          aria-label="Learn more about Remind Plans"
          eventKey={remindIconOnClickEventKey}>
          {remindIcon}
        </Button>
      );
    }
  };

  renderCloseButton = (startUrl: string) => {
    const { useHref } = this.props;
    const commonProps = {
      level: 'icon',
      onClick: () => this.track(this.getEventTrackingKey('close_button.click')),
      'aria-label': 'Close',
    };
    const closeGlyph = <Glyph name="close" color="thunder" size="xlarge" solo />;

    return useHref ? (
      <Button href={startUrl} {...commonProps}>
        {closeGlyph}
      </Button>
    ) : (
      <Button to={startUrl} {...commonProps}>
        {closeGlyph}
      </Button>
    );
  };

  render() {
    const { startUrl, quoteUuid, hideHelp } = this.props;
    return (
      <div className="AdminUpgradePageHeader">
        <div className="AdminUpgradePageHeader-container">
          <div className="AdminUpgradePageHeader-title">
            <Text size="medium">{this.props.title}</Text>
          </div>
          <div className="AdminUpgradePageHeader-items">
            <div>{this.renderRemindIcon()}</div>
            <Buttons reset="none" className="AdminUpgradePageHeader-right">
              <ZopimButton color="brand" level="secondary" size="small" />
              {!hideHelp && (
                <div className="AdminUpgradePageHeader-desktop AdminUpgradePageHeader-contact">
                  <AdminUpgradeHelp
                    quoteUuid={quoteUuid}
                    eventKey={this.getEventTrackingKey('help_button.click')}
                  />
                </div>
              )}
              {startUrl &&
                !userAgent.mobile() &&
                !this.props.hideClose &&
                this.renderCloseButton(startUrl)}
            </Buttons>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  if (state.adminUpgradePage.startUrl) {
    return { startUrl: state.adminUpgradePage.startUrl };
  }
  return {};
}
export { AdminUpgradePageHeader };
// $FlowFixMe
export default connect(mapStateToProps)(AdminUpgradePageHeader);
